import * as React from 'react';

export default props => {
    return <div>Checking Authentication...</div>;
};
